(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const main = document.getElementById("PdpMainImage");
    const back = document.getElementById("PdpBackImage");
    const flip = document.getElementById("PdpFlip");
    const thumbs = document.querySelectorAll("[data-pdp-thumb]");
    const qtyBox = document.querySelector(".pdp-qty");

    thumbs.forEach((btn) => {
      btn.addEventListener("click", () => {
        if (!main) return;
        if (back) {
          back.hidden = true;
          flip?.setAttribute("aria-pressed", "false");
        }
        main.hidden = false;
        const full = btn.getAttribute("data-full");
        const srcset = btn.getAttribute("data-srcset");
        if (full) main.src = full;
        if (srcset) main.srcset = srcset;
        thumbs.forEach((t) => {
          t.classList.remove("is-active");
          t.setAttribute("aria-pressed", "false");
        });
        btn.classList.add("is-active");
        btn.setAttribute("aria-pressed", "true");
      });
    });

    flip?.addEventListener("click", () => {
      if (!main || !back) return;
      const showingBack = flip.getAttribute("aria-pressed") === "true";
      flip.setAttribute("aria-pressed", showingBack ? "false" : "true");
      main.hidden = !showingBack;
      back.hidden = showingBack;
    });

    qtyBox?.querySelectorAll("[data-qty]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const input = qtyBox.querySelector('input[name="quantity"]');
        if (!input) return;
        const next = Math.max(1, Number(input.value || 1) + Number(btn.dataset.qty));
        input.value = String(next);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
